import { AccountCategory, AccountType, APIEndpoints, fiscalYearList } from "./Constants";
import { getNextNumber } from "./api";
import { globalValue } from "./modules/apps/AppContext";
import { BankTransactionType } from "./modules/banking/ViewBankTransactions";
import { generateShortUUID } from "./modules/misc_objects/Utils";
import { CashFlowType } from "./modules/transactions/BusinessTransactionForm";
import { getFiscalYearDates } from "./modules/utils/MiscFunctions";

export class CustomField {
  fieldName?: string;
  fieldValue?: string;
  constructor(init?: Partial<CustomField>) {
    Object.assign(this, init);
  }
}

export enum ItemTyp {
  Product = 'Product',
  Service = 'Service',
  Bundle = 'Bundle'
}

export class CacheTimeStamps {
  url?: string;
  lastRefreshed?: Date;
  constructor(init?: Partial<CacheTimeStamps>) {
    Object.assign(this, init);
  }
}

export interface URLTableMap {
  url: APIEndpoints,
  tables: string[],
}


export interface StockBalanceDto {
  itemId: string;
  itemNm: string;
  stockQty: number;
  itemCategory: string;
  itemGroup: string;
  uom: string;
  totalValue: number;
  rate: number;
}



export class RefTxns {

  txnId: string = '';


  txnNo?: string;


  contactName?: string;

  contactId?: string;


  itemId?: string;


  notes?: string;


  txnType?: TxnType;


  amount?: number;

  constructor(init?: Partial<RefTxns>) {
    Object.assign(this, init);
  }

}





export const PreDefinedDateFilters = [
  { value: 'Today', label: 'Today' },
  { value: 'Yesterday', label: 'Yesterday' },
  { value: 'ThisWeek', label: 'This Week' },
  { value: 'LastWeek', label: 'Last Week' },
  { value: 'ThisMonth', label: 'This Month' },
  { value: 'LastMonth', label: 'Last Month' },
  { value: 'Last30Days', label: 'Last 30 Days' },
  { value: 'Last90Days', label: 'Last 90 Days' },
  { value: 'ThisQuarter', label: 'This Quarter' },
  { value: 'LastQuarter', label: 'Last Quarter' },
  { value: 'ThisYear', label: 'This Year' },
  { value: 'LastYear', label: 'Last Year' },
  { value: 'Custom', label: 'Custom' },
];

export enum PaymentType {
  Credit = 'Credit',
  Cash = 'Cash'
}

export enum SystemAccountCode {
  Sale = "Sale",
  AP = "AP",
  AR = "AR",
  CASH = 'CASH',
  Purchase = "Purchase",
  TDS = 'TDS',
  SHIPPING = 'SHIPPING',
  COGS = 'COGS',
  STA = 'STA', //Stock Adjustment Account
  STE = 'STE', //TAX Expense Account
  STP = 'STP', //Tax Payable Accoun
  IA = 'IA',
  RE = 'RE',
  OBA = 'OBA', //Opening Balance Adjustments
  OBE = 'OBE'
}

export class LedgerReport {
  accountId: string = '';
  accountCode: string = '';
  accountName?: string;
  accountType?: AccountType;
  accountCategory?: AccountCategory;
  systemAccountCode?: SystemAccountCode;
  fiscalYear?: string;
  fiscalMonth?: number;
  itemId?: string;
  itemName?: string;
  contactId?: string;
  contactName?: string;
  debit?: number;
  credit?: number;
  debitYTD?: number;
  creditYTD?: number;
  amount?: number;
  amountYTD?: number;
  isHighlight?: boolean;
  isSummary?: boolean;
  constructor(init?: Partial<LedgerReport>) {
    Object.assign(this, init);
  }
}

export interface LastUpdates {
  tableName: string;
  updatedAt: Date;
}




export class Account {
  accountId?: string;
  systemAccountCode!: string;
  accountCode!: string;
  accountDesc?: string;
  accountName!: string;
  accountCategory!: AccountCategory;
  activeFlg!: boolean;
  accountType!: AccountType;
  openingBalanceAmt?: number;
  openingBalanceDate?: Date;
  subAccountFlg!: boolean;
  parentId!: string;
  app!: string;
  isDeleted!: boolean;

  constructor(init?: Partial<Account>) {
    Object.assign(this, init);
  }
}

export class Currency {
  currId: string;
  currName: string;
  currSymbol: string;

  constructor(init?: Partial<Currency>) {
    this.currId = init?.currId || '';
    this.currName = init?.currName || '';
    this.currSymbol = init?.currSymbol || '';
  }
}

export class Country {
  countryId: string;
  countryName: string;
  currId: string;

  constructor(init?: Partial<Country>) {
    this.countryId = init?.countryId || '';
    this.countryName = init?.countryName || '';
    this.currId = init?.currId || '';
  }
}

export interface SubTax {
  taxName: string;
  taxPct: number;
}

export class Tax {
  taxId: string;
  taxName: string;
  taxPct: number;
  compoundFlg: boolean;
  inputTaxAccount: string;
  outputTaxAccount: string;
  taxType: string;
  isTaxGroup?: boolean;
  taxAcct?: string;
  taxPayableAcct?: string;
  subTaxes: SubTax[] = [];
  intraTax?: boolean;
  interTax?: boolean;
  constructor(init?: Partial<Tax>) {
    this.taxId = init?.taxId || generateShortUUID();
    this.taxName = init?.taxName || '';
    this.taxPct = init?.taxPct || 0.00;
    this.compoundFlg = init?.compoundFlg || false;
    this.inputTaxAccount = init?.inputTaxAccount || '';
    this.outputTaxAccount = init?.outputTaxAccount || '';
    this.taxType = init?.taxType || '';
  }
}

export class SubItems {
  itemId: string = '';
  itemQty: number = 0;
}

export class Item {
  itemId: string = generateShortUUID();
  itemName?: string | null;
  itemTxt?: string;
  uomId?: string;
  barcode?: string;
  itemRate?: number;
  mrp?: number;
  isRateLocked?: boolean;
  salesAcct?: string;
  taxId?: string;
  purchaseRate?: number;
  purchaseAcct?: string;
  salesDesc?: string;
  purchaseDesc?: string;
  itemTyp?: string;
  inHsnCode?: string;
  inSacCode?: string;
  inIntratax?: string;
  inIntertax?: string;
  attchmntId?: string;
  attchmntName?: string;
  preferredVendor?: string;
  itemImages?: string[];
  inventoryFlag?: boolean = true;
  isActive: boolean = true;
  salesFlag: boolean = true;
  taxCalcType?: TaxCalcType;
  purchaseFlag: boolean = true;
  customFields?: CustomField[];
  stockBalance?: number;
  itemGroup: any;
  salesRate?: number;
  itemCode?: string;
  openingStockDate?: Date = new Date();
  openingStockQuantity?: number;
  openingStockPrice?: number;
  reorderQuantity?: number;
  stockTransId?: string;
  itemCategory?: string;
  subItems?: SubItems[] = [];
  secondaryUomId?: string;
  conversionFactor?: number;
  constructor(init?: Partial<Item>) {
    Object.assign(this, init);
  }
}

export class CustomFieldSettings {
  fieldName?: string;
  showField?: boolean;

  constructor(init?: Partial<CustomFieldSettings>) {
    Object.assign(this, init);
  }
}

// MBAI-437: an individual unapplied credit a contact holds — either an advance/unallocated
// payment or an unapplied credit note (SalesReturn) / debit note (PurchaseReturn)
export type ContactCreditSource = {
  sourceType: 'Payment' | 'CreditNote';
  sourceId: string;
  amount: number;
  date?: Date;
};

export class ContactBalance {
  contactId: string = '';
  receivables: number = 0;
  payables: number = 0;
  unallocatedReceivableCredit?: number;
  unallocatedPayableCredit?: number;
  receivableCreditSources?: ContactCreditSource[];
  payableCreditSources?: ContactCreditSource[];
  constructor(init?: Partial<ContactBalance>) {
    Object.assign(this, init);
  }
}

export class TemplateConfig {
  logoPosition?: string = 'top';
  docTitle?: string;
  billToLabel?: string;
  logoWidth?: number;
  sealWidth?: number;
  signatureWidth?: number;
  logoHeight?: number;
  showDescriptionBottom?: boolean;
  showReference?: boolean;
  showOrderType?: boolean;
  showSalesPerson?: boolean;
  showUom?: boolean;
  showEmail?: boolean = true;
  showDiscount?: boolean;
  pageSize?: string;
  pageOrientation?: string;
  occupyFullPage?: boolean;
  showStamp?: boolean = false;
  showSeal?: boolean;
  showBizName?: boolean = true;
  showWebsite?: boolean;
  showPhone?: boolean = true;
  showFax?: boolean;
  showAdditionalPhone?: boolean;
  showShipTo?: boolean = true;
  showContactTax?: boolean;
  showContactPhone?: boolean;
  showPaymentTerms?: boolean;
  showDueDate?: boolean;
  showPlaceOfSupply?: boolean;
  showPoNum?: boolean;
  showPoDate?: boolean;
  showTransportInfo?: boolean;
  // customFieldSettings?: CustomFieldSettings[];
  customFieldSettings?: CustomFieldSettings[];
  contactCustomFieldSettings?: CustomFieldSettings[];
  itemCustomFieldSettings?: CustomFieldSettings[];
  txnCustomFieldSettings?: CustomFieldSettings[];
  showLineItemNo?:boolean;
  showItemName?: boolean;
  showItemTxt?: boolean;
  showItemCode?: boolean;
  showUOM?: boolean;
  showMRP?: boolean;
  showUnitTotal?: boolean;
  showItemTax?: boolean;
  showItemDiscount?: boolean;
  showItemTaxAmt?: boolean;
  showTableTotal?: boolean;
  showItemAmt?: boolean;
  showAmountInWords?: boolean;
  showSubtotal?: boolean;
  showNetTotal?: boolean;
  showPackColumn?: boolean;
  showTax?: boolean;
  showCorpTax?: boolean;
  showShippingCharges?: boolean;
  showShippingTax?: boolean;
  showGrandTotal?: boolean;
  showPaymentMade?: boolean;
  showBalanceDue?: boolean;
  showInvoiceBalance?: boolean;
  showRoundOffDifference?: boolean;
  showReceivables?: boolean;
  showTotalSavings?: boolean;
  showTerms?: boolean;
  showNotes?: boolean;
  showDeclaration?: boolean;
  showBankDetails?: boolean;
  showFooterText?: boolean;
  showUPIQRCode?: boolean;
  showTaxSummary?: boolean;
  showAuthorizedSignatory?: boolean;
  showAcknowledgement?: boolean;
  signatureHeight?: number;
  stampWidth?: number;
  stampHeight?: number;
  isDefault?: boolean;
  object?: string;
  template?: string;
  footerTxt?: string;
  accent?: string;
  accentSecondary?: string;
  fontSize?: string;
  fontType?: string;
  variant?: string;
  twoLineItem: boolean | undefined;
  constructor(init?: Partial<TemplateConfig>) {
    Object.assign(this, init);
  }
}

export enum ContactType {
  Customer = 'Customer',
  Vendor = 'Vendor',
  Employee = 'Employee'
}

export enum ResetType {
  Yearly = 'Yearly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export interface NumberRanges {
  object: string;
  txt?: string;
  prefix?: string;
  reset?: ResetType;
  numericLength?: number;
  nextNumber?: number;
  isDisabled?: boolean
}

export interface Address {
  addressName?: string;
  addressDetail: string;
  addressType?: 'shipping' | 'billing';
}

export class Contact {

  contactId: string = generateShortUUID();
  category: any;
  customFields?: CustomField[];
  contactName?: string;
  website?: string;
  currId?: string;
  custFlg?: boolean;
  shippingAddress?: string;
  billingAddress?: string;
  firstName?: string;
  lastName?: string;
  workPhone?: string;
  taxIdNo?: string;
  taxExempt?: boolean;
  panNo?: string;
  mobileNumber?: string;
  companyName?: string;
  emailTxt?: string;
  contactCategory?: string;
  contactGroup?: string;
  vendorFlg?: boolean;
  paymentTerms?: string;
  contactTyp: ContactType[] = [];
  isBusiness?: boolean;
  parentContact?: string;
  branchFlg?: boolean;
  faxNumber?: string;
  inGSTNo?: string;
  inGSTRegister?: string;
  inGSTTreatment?: string;
  deleteDate?: Date;
  docDt?: Date;
  receivableAmt?: number;
  receivableDate?: Date;
  payableAmt?: number;
  payableDate?: Date;
  creditLimit?: number;
  noLateFee?: boolean;
  openingBalance?: number;
  contactImages?: [];
  openingBalanceDate?: Date;
  property?: string;
  refTxnId?: string;
  addresses?: Address[];
  portalAccess?: boolean;
  portalEmail?: string;
  // deleteFlg?: boolean;

  constructor(init?: Partial<Contact>) {
    if (init) {
      Object.keys(init).forEach(key => {
        if (key in this) {
          (this as any)[key] = init[key as keyof Contact];
        }
      });
    }
  }
}

export class PaymentTerms {
  paymentTermId: string = generateShortUUID();
  name?: string;
  description?: string;
  days: number = 0;

  constructor(init?: Partial<PaymentTerms>) {
    Object.assign(this, init);
  }
}

export class BranchDetails {
  branchId: string = generateShortUUID();;
  branchName?: string;
  country?: string;
  currency?: string;
  timeZone?: string;

  constructor(init?: Partial<BranchDetails>) {
    Object.assign(this, init);
  }
}


export enum AttrType {
  ItemCategory = "ItemCategory",
  ItemGroup = "ItemGroup",
  Tags = "Tags",
  ContactCategory = "ContactCategory",
  ContactGroup = "ContactGroup",
  SalesPerson = "SalesPerson",
  PaymentMode = "PaymentMode",
  Reason = "Reason",
  PortCode = 'PortCode',
  OrderStatus = 'OrderStatus',
  OrderType = 'OrderType',
  Property = 'Property'
}

export class ZAttributes {
  attrId: string = generateShortUUID();
  attrNm: string = '';
  attrTxt?: string;
  attrType?: AttrType;
  attrColor?: string;
  backendSync?: boolean;
  isDeleted?: boolean;
  constructor(init?: Partial<ZAttributes>) {
    Object.assign(this, init);
  }
}

export type StockPrice = {
  lineId: number;
  qty: number;
  rate: number;
  txnId?: string;
};


export type StockLedger = {
  stockTxnId: string;
  txnDate: Date;
  itemId: string;
  itemName?: string;
  rate?: number;
  itemQty?: number;
  notes?: string;
  stockTxnType: StockTxnType;
  purchaseRate?: number;
  stockBalance?: number;
  stockValue?: number;
  parentTxnId?: string;
  parentTxnNo?: string;
  parentTxnType?: TxnType;
  sourceStockInfo?: StockPrice[];
};


export enum TxnType {
  Bills = "Bills",
  PurchaseBills = "PurchaseBills",
  PurchaseOrder = "PurchaseOrder",
  PurchaseReturn = "PurchaseReturn",
  SalesOrder = "SalesOrder",
  Invoice = "Invoice",
  Expense = "Expense",
  Estimate = "Estimate",
  ProformaInvoice = "ProformaInvoice",
  Delivery = "Delivery",
  SalesReturn = "SalesReturn",
  StockAdjustment = "StockAdjustment",
  OpeningReceivable = 'OpeningReceivable',
  OpeningPayables = 'OpeningPayables',
}

export enum ReportQueryType {
  CustomerBase = "CustomerBase",
  VendorBase = "VendorBase",
  CombinedBase = 'CombinedBase',
}


export class TaxBreakup {


  taxId?: string;


  taxName?: string;


  taxPct?: number;


  taxAcct?: string;


  taxAmt: number = 0;

  taxGroupRate?: number;

  itemId?: string;

  constructor(init?: Partial<TaxBreakup>) {
    Object.assign(this, init);
  }


}

export class TxnTaxes {
  taxName?: string;
  taxId?: string;
  taxPct?: number;
  taxAmt?: number;

  constructor(data: Partial<LineItem> = {}) {
    Object.assign(this, data);
  }
}

export enum TaxCalcType {
  Exclusive = "Exclusive",
  Inclusive = "Inclusive"
}

export class LineItem {
  lineId?: number;
  itemId?: string;
  acctId?: string;
  itemName?: string;
  itemTxt?: string;
  itemRate?: number;
  itemQty?: number;
  itemAmt?: number;
  uomId?: string;
  taxId?: string;
  taxPct?: number;
  taxIncl?: boolean;
  discountAmt?: number;
  discountPct?: number;
  pricingName?: string;
  isDiscountPct?: boolean;
  inventoryFlag?: boolean = true;
  inItc?: string;
  deleteFlag?: boolean;
  tagId?: string;
  taxAmt?: number;
  amtBeforeTax?: number;
  isUpdated?: boolean;
  milestoneId?: string;
  selectedUomId?: string;
  lineConversionFactor?: number;
  constructor(data: Partial<LineItem> = {}) {
    Object.assign(this, data);
  }
}

export enum StockTxnType {
  Inward = "Inward",
  Outward = "Outward",
  OpeningBalance = "OpeningBalance",
  ClosingBalance = "ClosingBalance"
}

export enum TxnStatus {
  Saved = 'Saved',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  Void = 'Void',
  Draft = 'Draft',
  PartiallyPaid = 'PartiallyPaid',
  LateFeeOutstanding = 'LateFeeOutstanding',
}

export enum LateFeeType {
  Fixed      = 'Fixed',
  Percentage = 'Percentage',
  Interest   = 'Interest',
}

export enum LateFeePeriod {
  OneTime  = 'OneTime',
  Daily    = 'Daily',
  Weekly   = 'Weekly',
  Monthly  = 'Monthly',
}

export enum LateFeePostMode {
  SameInvoice     = 'SameInvoice',
  SeparateInvoice = 'SeparateInvoice',
}

export interface LateFeeSettings {
  enabled: boolean;
  autoPost?: boolean;
  postMode?: LateFeePostMode; // defaults to SameInvoice when unset
  feeType: LateFeeType;
  fixedAmount?: number;
  percentage?: number;
  annualRate?: number;
  period: LateFeePeriod;
  gracePeriodDays: number;
  maxFeeCap?: number;
  maxFeeCapPct?: number;
  lateFeeAccountId?: string;
  lateFeeAccountName?: string;
  activationDate?: Date;
}

export interface LateFeePosting {
  postingId: string;
  postedAt: Date;
  periodStart: Date;
  periodEnd: Date;
  basedOnBalance: number;
  feeType: LateFeeType;
  rate: number;
  feeAmt: number;
  isReversed: boolean;
  reversedAt?: Date;
  reversalReason?: string;
  feeTxnId?: string;  // SeparateInvoice mode: the Late Fee invoice raised for this posting
  feeTxnNo?: string;
}

export enum PaymentType {
  CustomerPayment = "CustomerPayment",
  SalesReturnAllocation = "SalesReturnAllocation",
  VendorPayment = "VendorPayment",
  PurchaseReturnAllocation = "PurchaseReturnAllocation",
}

export class TxnPayments {
  paymentId?: string;
  paymentDate?: string;
  paymentAmount?: string;
}

export class SendEmailDto {
  toEmails?: string[];
  ccEmails?: string[];
  note?: string;
  htmlContent?: string;
  docId?: string;
  txnId?: string;
  txnType?: string;
  paymentUrl?: string;
  balanceDue?: string;
  constructor(data: Partial<SendEmailDto> = {}) {
    Object.assign(this, data);
  }
}

export interface GatewayConfig {
  activeProvider: string;
  razorpay_keyId?: string;
  razorpay_keySecret?: string;
  razorpay_webhookSecret?: string;
  razorpay_depositAccountId?: string;
  phonepe_merchantId?: string;
  phonepe_saltKey?: string;
  phonepe_saltIndex?: string;
  phonepe_env?: string;
  phonepe_depositAccountId?: string;
  stripeConnect_accountId?: string;
  stripeConnect_onboarded?: boolean;
  stripeConnect_depositAccountId?: string;
  webhookUrls?: { razorpay: string };
}

export interface TestGatewayConnectionResult {
  success: boolean;
  message: string;
}

export interface PublicPaymentInitResult {
  logId: string;
  gateway: string;
  orderId?: string;
  keyId?: string;
  clientSecret?: string;
  redirectUrl?: string;
  // Stripe Connect only — the connected account clientSecret belongs to. Stripe.js must be
  // initialized with { stripeAccount: accountId } to confirm it (MBAI-177).
  accountId?: string;
}

export interface PublicPaymentStatus {
  status: string;
  amount: number;
  currency: string;
}



export class TxnHeader {
  txnId: string;
  txnNo?: string;
  txnType?: string; // Assuming TxnType is a string, adjust if different
  txnDate?: Date;
  stockTxnType?: StockTxnType;
  dueDate?: Date;
  createBy?: string;
  createDate?: Date;
  createDevice?: string;
  modifyBy?: string;
  modifyDevice?: string;
  modifyDate?: Date;
  contactId?: string;
  contactName?: string;
  paymentType?: string;
  poNum?: string;
  poDate?: Date;
  salesPerson?: string;
  totalAmtTC?: number; //Amount in Transaction Currency
  totalAmt?: number;
  subtotalAmt?: number;
  txnDescription?: string;
  discountAmt?: number;
  discountPct?: number;
  isDiscountPct?: boolean;
  shippingAmt?: number;
  shippingAcct?: string;
  shippingtaxId?: string;
  shippingtaxAmt?: number;
  withHoldingTaxAcct?: string;
  withHoldingAmt?: number;
  otherChargesAcct?: string;
  otherChargesAmt?: number;
  roundOffAmt?: number;
  paymentAllocAmt?: number;
  paymentAmt?: number;
  fxRateAmt?: number;
  attachmentId?: string;
  notes?: string;
  reference?: string;
  reason?: string;
  terms?: string;
  salesPersonId?: string;
  orderStatus?: string;
  currencyId?: string;
  billingAddress?: string;
  shippingAddress?: string;
  paymentTermsId?: string;
  txnStatus?: TxnStatus;
  isDeleted?: boolean;
  tags?: string[];
  receivedAcctId?: string;
  transportInfo?: string;
  placeOfSupply?: string;
  selfRefDocId?: string;
  selfRefDocType?: string;
  inSupplyType?: string;
  inStateCode?: string;
  inGSTTreatment?: string;
  inPortCode?: string;
  inItc?: string;
  taxId?: string;
  taxType?: TaxCalcType;
  inGstRegister?: string;
  inGstNo?: string;
  inReverseCharge?: boolean
  txnTaxes?: TxnTaxes[];
  txnAcct?: string;
  expenseAcct?: string;
  bankTxnId?: string;
  paymentAcct?: string;
  payViaAP?: boolean;
  paymentMode?: string;
  employee?: string;
  txnPayments?: TxnPayments[];
  billedCustomer?: string; // Only for Expense incase of billableExpense
  billableExpense?: boolean;
  customFields?: CustomField[];
  balanceDue?: number;
  recurrenceInterval?: string;
  recurrenceStartDate?: Date;
  recurrenceEndDate?: Date;
  recurrenceDisabled?: boolean;
  recurrenceSend?: boolean;
  recurrenceName?: string;
  createdByRecurrence?: string;
  // MBAI-150: set instead of createdByRecurrence on every instance generated from a
  // new-model RecurringTemplate -- the two fields are never both set on the same Txn.
  generatedFromTemplateId?: string;
  recurrenceLastRun?: Date;
  nextRecurrenceDate?: Date;
  property?: string;

  // Export Invoice Specific Fields (from your template)
  exporterRef?: string;
  buyerName?: string;
  buyerAddress?: string;
  buyerPhone?: string;
  otherRef?: string;
  preCarriage?: string;
  placeOfReceipt?: string;
  vesselFlight?: string;
  portOfLoading?: string;
  portOfDischarge?: string;
  countryOfOrigin?: string;
  countryOfDestination?: string;
  paymentTerms?: string;
  deliveryTerms?: string;
  declaration?: string;
  additionalInfo?: string;
  gstNo?: string;
  iecNo?: string;
  panNo?: string;
  adCode?: string;
  lut?: string; // Letter of Undertaking

  exportType?: string; // Export Type (Commercial, Non-Commercial, etc.)
  exportPurpose?: string; // Purpose of Export

  // Exchange Rate and Currency Information
  exchangeRate?: number; // Exchange Rate at time of export
  exchangeRateDate?: Date; // Date of Exchange Rate
  foreignCurrencyAmt?: number; // Amount in Foreign Currency

  // Container and Packaging Information
  totalPackages?: number; // Total Number of Packages
  packageType?: string; // Type of Packaging
  grossWeight?: number; // Gross Weight
  netWeight?: number; // Net Weight
  weightUnit?: string; // Weight Unit (KG, LBS, etc.)

  // Shipping Bill and Documentation
  shippingBillNo?: string; // Shipping Bill Number
  shippingBillDate?: Date; // Shipping Bill Date
  exportOrderNo?: string; // Export Order Number
  exportOrderDate?: Date; // Export Order Date

  // Banking and Finance
  lcNo?: string; // Letter of Credit Number
  lcDate?: Date; // Letter of Credit Date
  advanceLicenseNo?: string; // Advance License Number
  drawbackAmount?: number; // Duty Drawback Amount
  convertedFromTxnId?: string;
  convertedFromTxnType?: string; // MBAI-324: original txn type for building the view link
  shipToName?: string;
  // Late fee fields
  lateFeeAmt?: number;           // Transient — sum of non-reversed lateFeePostings, computed by backend
  daysOverdue?: number;          // Transient — computed by backend, not stored
  lateFeePostings?: LateFeePosting[]; // Persisted — individual fee postings; reverse via reverseLateFee()
  // e-Invoice fields (India GST)
  irn?: string;
  irnAckNo?: string;
  irnAckDate?: Date;
  eInvoiceQr?: string;
  projectId?: string;
  constructor(data: Partial<TxnHeader> = {}, txnType?: string) {
    this.txnId = generateShortUUID();
    this.txnType = txnType;
    Object.assign(this, data);
  }
}

export interface OverDueReminder {
  days?: number;          // Optional number of days for overdue reminder
  sendText?: boolean;     // Flag to send text reminders
  sendEmail?: boolean;    // Flag to send email reminders
}

export interface OverDueReminderSchedule {
  onDueDate: boolean;
  after3Days: boolean;
  after1Week: boolean;
  after1Month: boolean;
}

export interface AutoPaymentReminders {
  enabled: boolean;
  schedule: OverDueReminderSchedule;
  sendWhatsApp?: boolean;  // MBAI-422: send via WhatsApp in addition to email
}

export interface AiSettings {
  reportInsightsEnabled?: boolean;
  statusBriefEmailEnabled?: boolean;
  statusBriefEmailTime?: string; // HH:mm, e.g. '08:00'
}

export interface BusinessSummarySettings {
  enabled: boolean;
  frequency: 'daily' | 'weekly' | 'monthly';
  dayOfWeek?: number;    // 0–6; only used when frequency === 'weekly'
  dayOfMonth?: number;   // 1–28; only used when frequency === 'monthly'
  period?: string;       // PreDefinedDateFilters key; auto-selected if absent
  email?: string;        // override recipient; falls back to bizDetails.email
}

export interface BizSettings {
  allowNegativeInventory?:boolean
  inventoryFlag?: boolean;            // Optional flag to enable inventory
  barCodeConfiguration?: boolean;     // Optional flag for barcode configuration
  enableProformaInvoice?: boolean;
  overdueReminder?: OverDueReminder;  // Optional overdue reminder settings
  autoPaymentReminders?: AutoPaymentReminders;
  exportRel?: boolean;
  taxFlag?: boolean;
  lateFeeSettings?: LateFeeSettings;
  businessSummary?: BusinessSummarySettings;
  language?: string;                  // Preferred UI language (e.g. 'en', 'es', 'fr')
  eInvoiceEnabled?: boolean;          // India GST e-Invoice generation
  fyLockDate?: Date;                   // MBAI-468: transactions on/before this date are read-only
  manufacturingSettings?: ManufacturingSettings;
  projectSettings?: ProjectSettings;
  budgetSettings?: BudgetSettings;
  aiSettings?: AiSettings;
  enableRecurrence?: boolean;         // Per-biz opt-in for recurrence, enforced only when the brand requires it (see BrandSettings.recurrenceRequiresBizOptIn)
}

export interface ManufacturingSettings {
  enabled?: boolean;
  wipAccount?: string;
}

export type BOMStatus = 'Active' | 'Archived';
export type WorkOrderStatus = 'Planned' | 'InProgress' | 'Completed' | 'Cancelled';

export interface BOMOutput {
  itemId: string;
  itemNm?: string;
  qty: number;
  uomId?: string;
}

export interface BOMComponent {
  itemId: string;
  itemNm?: string;
  qty: number;
  uomId?: string;
}

export interface BOMCostLine {
  accountId: string;
  accountNm?: string;
  description?: string;
  amount: number;
}

export interface BOM {
  bomId?: string;
  bomName: string;
  status?: BOMStatus;
  outputs?: BOMOutput[];
  components?: BOMComponent[];
  costLines?: BOMCostLine[];
  notes?: string;
  bizId?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface WorkOrderOutput {
  itemId: string;
  itemNm?: string;
  uomId?: string;
  plannedQty: number;
  actualQty?: number;
}

export interface WorkOrderLine {
  itemId: string;
  itemNm?: string;
  uomId?: string;
  plannedQty: number;
  actualQty?: number;
}

export interface WorkOrderCostLine {
  accountId: string;
  accountNm?: string;
  description?: string;
  amount: number;
}

export interface WorkOrder {
  workOrderId?: string;
  workOrderNo?: string;
  status?: WorkOrderStatus;
  bomId: string;
  bomName?: string;
  batchQty: number;
  plannedDate?: Date;
  completedDate?: Date;
  notes?: string;
  outputs?: WorkOrderOutput[];
  components?: WorkOrderLine[];
  costLines?: WorkOrderCostLine[];
  bizId?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export class Txn {
  txnHeader: TxnHeader;
  lineItems?: LineItem[];
  bizId?: string;
  app?: string;

  constructor(data: Partial<Txn> = {}, txnType?: string) {
    this.txnHeader = new TxnHeader(data.txnHeader || {}, txnType);
    this.lineItems = (data.lineItems || []).map(item => new LineItem(item));
    this.bizId = data.bizId;
    this.app = data.app;
  }
}


export class PaymentHeader {
  paymentId: string;
  paymentNo?: string;
  paymentType?: PaymentType; // Assuming TxnType is a string, adjust if different
  paymentDate?: Date;
  createBy?: string;
  createDate?: Date;
  createDevice?: string;
  modifyBy?: string;
  modifyDevice?: string;
  modifyDate?: Date;
  contactId?: string;
  contactName?: string;
  totalAmtTC?: number; //Amount in Transaction Currency
  totalAmt: number = 0;
  subtotalAmt?: number;
  discountAmt?: number;
  discountPct?: number;
  isDiscountPct?: boolean;
  withHoldingTaxAcct?: string;
  withHoldingAmt?: number;
  otherChargesAcct?: string;
  otherChargesAmt?: number;
  cashRefundAcct?: string;
  cashRefundAmt?: number;
  returnTxnId?: string;
  paymentAmt?: number;
  fxRateAmt?: number;
  attachmentId?: string;
  notes?: string;
  reference?: string;
  terms?: string;
  currencyId?: string;
  paymentTermsId?: string;
  reason?: string;
  paymentStatus?: string;
  isDeleted?: boolean;
  tags?: string[];
  receivedAcctId?: string;
  inItc?: string;
  taxId?: string;
  taxType?: TaxCalcType;
  txnTaxes?: TxnTaxes[];
  paymentAcct?: string;
  paymentMode?: string;
  bankTxnId?: string;
  employee?: string;
  billedCustomer?: string; // Only for Expense incase of billableExpense
  billableExpense?: boolean;
  projectId?: string;
  advanceTxnId?: string;
  isAdvancePayment?: boolean;
  constructor(data: Partial<PaymentHeader> = {}, paymentType?: PaymentType) {
    this.paymentId = generateShortUUID();
    this.paymentType = paymentType;
    Object.assign(this, data);
  }
}

export class PaymentLines {
  lineId?: number;
  txnId?: string;
  txnNo?: string;
  txnDate?: Date;
  totalAmt?: number;
  dueAmt?: number;
  acctId?: string;
  contactId?: string;
  allocAmt?: number;
  discountAmt?: number;
  discountPct?: number;
  isDiscountPct?: boolean;
  deleteFlag?: boolean;
  notes?: string;
  constructor(data: Partial<PaymentLines> = {}) {
    Object.assign(this, data);
  }
}

export class Payment {
  paymentHeader: PaymentHeader;
  paymentLines?: PaymentLines[];
  bizId?: string;
  app?: string;
  constructor(data: Partial<Payment> = {}, paymentType?: PaymentType) {
    this.paymentHeader = new PaymentHeader(data.paymentHeader || {}, paymentType);
    this.paymentLines = (data.paymentLines || []).map(paymentLine => new PaymentLines(paymentLine));
    this.bizId = data.bizId;
    this.app = data.app;
  }
}

export class LedgerLines {
  lineNo: number = 0;
  accountId?: string;
  accountName?: string; // This field is optional and should not be saved
  accountType?: AccountType;
  accountCategory?: AccountCategory;
  systemAccountCode?: SystemAccountCode;
  stmntText?: string;
  debit?: number;
  credit?: number;
  balance?: number;
  refTxns?: RefTxns;
  ledgerId?: string;
  constructor(data: Partial<LedgerLines> = {}) {
    Object.assign(this, data);
  }
}

export enum LedgerType {
  GeneralEntry = "GeneralEntry",
  CashReceipt = "CashReceipt",
  CustomerInvoice = "CustomerInvoice",
  IncomingPayment = "IncomingPayment",
  SupplierBill = "SupplierBill",
  OutgoingPayment = "OutgoingPayment",
  OpeningBalance = "OpeningBalance",
  StockAdjustment = "StockAdjustment",
  BusinessTransaction = "BusinessTransaction",
  Journal = "Journal",
  TaxPayment = 'TaxPayment',
  TaxAdjustment = 'TaxAdjustment'
}

export class Ledger {
  ledgerId: string = generateShortUUID();
  ledgerDate: Date = new Date();
  ledgerLines?: LedgerLines[] = [];
  ledgerNo?: string;
  totalAmt?: number;
  note?: string;
  ledgerType?: LedgerType;
  attachmentId?: string;
  tags?: string[];
  isDeleted?: boolean;
  reference?: string;
  bankTxnId?: string;
  paymentMode: string | undefined;
  businessTransaction?: string;
  cashFlowType?: CashFlowType;
  constructor(data: Partial<Ledger> = {}) {
    Object.assign(this, data);
  }
}

export class AutoMatchSuggestion {
  objectId?: string;
  objectType?: string;
  objectNo?: string;
  // Only set for Invoice/Bills suggestions — the contact to preselect when the confirmed
  // suggestion routes into the Customer/Vendor Payment form instead of a direct link.
  contactId?: string;
  // Open Invoice/Bill candidates also carry what the card shows: who owes/is owed, the
  // outstanding balance the bank amount matched, and when it's due.
  contactName?: string;
  amount?: number;
  dueDate?: Date | string;
}



export class DateFilter {
  predefinedDateFilter: string = 'ThisWeek';
  fromDate?: Date;
  toDate?: Date;

  constructor(data: Partial<DateFilter> = {}, periodType?: 'periodic' | 'YTD' | 'BTD') {
    this.predefinedDateFilter = data.predefinedDateFilter || 'ThisWeek';
    this.fromDate = data.fromDate ? new Date(data.fromDate) : undefined;
    this.toDate = data.toDate ? new Date(data.toDate) : undefined;
    this.updateDates(periodType); // Set initial fromDate and toDate based on predefinedDateFilter and optional periodType
  }

  get getPredefinedDateFilter(): string {
    return this.predefinedDateFilter;
  }

  set setPredefinedDateFilter(value: string) {
    this.predefinedDateFilter = value;
    this.updateDates(); // Update the fromDate and toDate whenever predefinedDateFilter changes
  }

  updateDates(periodType?: 'periodic' | 'YTD' | 'BTD') {

    const timezone_to_use = globalValue?.bizMaster?.bizDetails?.timeZone || 'UTC';
    // Helper function to set start of day in timezone
    const setStartOfDay = (date: Date): Date => {
      // Get the date string in the target timezone
      const dateStr = date.toLocaleDateString('en-CA', { timeZone: timezone_to_use }); // YYYY-MM-DD format
      const [year, month, day] = dateStr.split('-').map(Number);

      // Create date at start of day in UTC, then adjust for timezone offset
      const targetDate = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));

      // Get timezone offset in minutes at this date
      const tzDate = new Date(targetDate.toLocaleString('en-US', { timeZone: timezone_to_use }));
      const utcDate = new Date(targetDate.toLocaleString('en-US', { timeZone: 'UTC' }));
      const offset = (utcDate.getTime() - tzDate.getTime());

      return new Date(targetDate.getTime() + offset);
    };

    // Helper function to set end of day in timezone
    const setEndOfDay = (date: Date): Date => {
      // Get the date string in the target timezone
      const dateStr = date.toLocaleDateString('en-CA', { timeZone: timezone_to_use }); // YYYY-MM-DD format
      const [year, month, day] = dateStr.split('-').map(Number);

      // Create date at end of day in UTC, then adjust for timezone offset
      const targetDate = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));

      // Get timezone offset in minutes at this date
      const tzDate = new Date(targetDate.toLocaleString('en-US', { timeZone: timezone_to_use }));
      const utcDate = new Date(targetDate.toLocaleString('en-US', { timeZone: 'UTC' }));
      const offset = (utcDate.getTime() - tzDate.getTime());

      return new Date(targetDate.getTime() + offset);
    };

    // Get current date in the specified timezone
    const nowStr = new Date().toLocaleDateString('en-CA', { timeZone: timezone_to_use });
    const [nowYear, nowMonth, nowDay] = nowStr.split('-').map(Number);
    const now = new Date(nowYear, nowMonth - 1, nowDay);
    const year = now.getFullYear();
    const month = now.getMonth();
    // Use global fiscal year or default to "FY-Standard-April-March"
    const fiscalYear = globalValue?.bizMaster?.bizDetails?.fiscalYear || "FY-January-December";
    const fiscalYearConfig = fiscalYearList.find(fy => fy.id === fiscalYear) || fiscalYearList.find(fy => fy.id === "FY-January-December");
    // Default date range based on the predefined filter
    switch (this.predefinedDateFilter) {
      case 'Today':
        this.fromDate = setStartOfDay(now);
        this.toDate = setEndOfDay(now);
        break;
      case 'Yesterday':
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        this.fromDate = setStartOfDay(yesterday);
        this.toDate = setEndOfDay(yesterday);
        break;

      case 'ThisWeek':
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay());
        this.fromDate = setStartOfDay(startOfWeek);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        this.toDate = setEndOfDay(endOfWeek);
        break;

      case 'LastWeek':
        const lastWeekStart = new Date(now);
        lastWeekStart.setDate(now.getDate() - now.getDay() - 7);
        this.fromDate = setStartOfDay(lastWeekStart);

        const lastWeekEnd = new Date(lastWeekStart);
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
        this.toDate = setEndOfDay(lastWeekEnd);
        break;

      case 'ThisMonth':
        this.fromDate = setStartOfDay(new Date(year, month, 1));
        this.toDate = setEndOfDay(new Date(year, month + 1, 0));
        break;

      case 'LastMonth':
        this.fromDate = setStartOfDay(new Date(year, month - 1, 1));
        this.toDate = setEndOfDay(new Date(year, month, 0));
        break;

      case 'Last30Days': {
        const last30Start = new Date(now);
        last30Start.setDate(now.getDate() - 29);
        this.fromDate = setStartOfDay(last30Start);
        this.toDate = setEndOfDay(now);
        break;
      }

      case 'Last90Days': {
        const last90Start = new Date(now);
        last90Start.setDate(now.getDate() - 89);
        this.fromDate = setStartOfDay(last90Start);
        this.toDate = setEndOfDay(now);
        break;
      }

      case 'ThisYear':
        ({ fromDate: this.fromDate, toDate: this.toDate } = getFiscalYearDates(fiscalYearConfig, 0, timezone_to_use));
        break;

      case 'LastYear':
        ({ fromDate: this.fromDate, toDate: this.toDate } = getFiscalYearDates(fiscalYearConfig, -1, timezone_to_use));
        break;

      case 'ThisQuarter':
        const thisQuarterStart = this.getQuarterStart(month, year);
        const thisQuarterEnd = this.getQuarterEnd(month, year);
        this.fromDate = setStartOfDay(thisQuarterStart);
        this.toDate = setEndOfDay(thisQuarterEnd);
        break;

      case 'LastQuarter':
        const lastQuarterStartMonth = ((Math.floor(month / 3) - 1 + 4) % 4) * 3;
        const lastQuarterYear = lastQuarterStartMonth > month ? year - 1 : year;
        this.fromDate = setStartOfDay(this.getQuarterStart(lastQuarterStartMonth, lastQuarterYear));
        this.toDate = setEndOfDay(this.getQuarterEnd(lastQuarterStartMonth, lastQuarterYear));
        break;

      case 'AllTime':
        this.fromDate = new Date(0); // January 1, 1970
        this.toDate = (new Date()); // Current date and time in timezone
        break;
      case 'Custom':
        // Ensure `fromDate` and `toDate` have fallback default values
        const fromDate = this.fromDate || now;
        const toDate = this.toDate || now;

        this.fromDate = setStartOfDay(fromDate);
        this.toDate = setEndOfDay(toDate);
        break;
      default:
        break;
    }

    // Handle optional periodType overrides for YTD or BTD
    if (periodType === 'YTD') {
      if (this.toDate && fiscalYearConfig) {
        // Derive the FY start that contains toDate, regardless of how far back it is.
        const startParts = fiscalYearConfig.start.split('/');
        const fyStartMonth = parseInt(startParts[1], 10) - 1; // 0-indexed
        const fyStartDay = parseInt(startParts[0], 10);
        const toYear = this.toDate.getFullYear();
        const fyStartInToYear = new Date(toYear, fyStartMonth, fyStartDay);
        const fyStartYear = this.toDate < fyStartInToYear ? toYear - 1 : toYear;
        this.fromDate = setStartOfDay(new Date(fyStartYear, fyStartMonth, fyStartDay));
      } else {
        this.fromDate = getFiscalYearDates(fiscalYearConfig).fromDate;
      }
    } else if (periodType === 'BTD') {
      this.fromDate = new Date(0); // January 1, 1970
    }
  }

  // Helper methods for quarter calculations
  private getQuarterStart(month: number, year: number): Date {
    const quarter = Math.floor(month / 3);
    return new Date(year, quarter * 3, 1); // Start of the current quarter
  }

  private getQuarterEnd(month: number, year: number): Date {
    const quarter = Math.floor(month / 3);
    return new Date(year, (quarter + 1) * 3, 0, 23, 59, 59, 999); // End of the current quarter
  }
}



export enum AccountingType {
  Accrual = 'Accrual',
  Cash = 'Cash'
}

export enum FieldType {
  string = "string",
  number = "number",
  boolean = 'boolean',
  date = 'date',
  currAmt = 'currAmt'
}

export enum MyBooksObject {
  Item = 'Item',
  Txn = 'Txn',
  Payment = 'Payment',
  Contact = 'Contact',
  BankTransactions = 'BankTransactions',
  Account = "Account",
  Journal = "Journal",
  BusinessTransaction = "BusinessTransaction"
}



export interface UploadOptions {
  uploadObject?: MyBooksObject; // Adjust this type based on your frontend definition
  simulate?: boolean;
  overWrite?: boolean;
  bankAcct?: string;
  subType?: string;
  partialUpload?: boolean; // This should allow partial successful records to be saved
}

export class AppLogFilter {
  logType?: string[];
  logSubType?: string[];
  logLevel?: string[];
  objectType?: string[];
  userId?: string[];
  device?: string[];

  constructor(init?: Partial<AppLogFilter>) {
    Object.assign(this, init);
  }
}


export interface AuditChange {
  field: string;
  old?: string;
  new?: string;
}

export interface AppLog {
  logId: string;
  logType: string;
  createdAt: Date;
  logSubType: string;
  logDetail: string[];
  logLevel: string;
  objectType: string;
  objectId: string;
  logSummary: string;
  isSuccess: boolean;
  app: string;
  userId: string;
  userName?: string;
  device: string;
  bizId: string;
  changes?: AuditChange[];
}

export interface UploadHistoryResponse {
  logs: AppLog[];
  total: number;
  page: number;
  totalPages: number;
}

export interface AuditReportResponse {
  logs: AppLog[];
  total: number;
  page: number;
  totalPages: number;
}

export interface DownloadListRequest {
  tableConfigList?: TableConfig[];
  requestBody: any;
}


export class TableConfig {
  object: string = '';

  screen?: string;

  fieldName?: string;

  fieldHeading?: string;

  fieldLength?: 'large' | 'medium' | 'small';

  fieldType?: FieldType;

  isVisible?: boolean;

  sortOrder?: number;

  attrType?: string;

  className?: string;

  isStandard?: boolean

  size?: 'large' | 'medium' | 'small';

  constructor(data: Partial<TableConfig> = {}) {
    Object.assign(this, data);
  }
}

export class FieldConfig {
  object: string = '';

  screen?: string;

  fieldName?: string;

  fieldHeading?: string;

  fieldType?: FieldType;

  isVisible?: boolean;

  isSpecialPlaced?: boolean;

  fieldValue?: string;

  sortOrder?: number;

  isStandard?: boolean;

  isDeleted?: boolean;

  className?: string;

  constructor(data: Partial<FieldConfig> = {}) {
    Object.assign(this, data);
  }
}

export enum BankType {
  CreditCard = "CreditCard",
  Bank = "Bank",
  Cash = "Cash"
}

export interface BankTransactionQueryOptions {
  bankAcct?: string;
  dateFilter?: DateFilter;
  getCategorized?: boolean;
  sortBy?: string; // e.g., 'txnDate' or other fields
  // Leave out the (slow) auto-match / rule suggestions; fetch them via getBankSuggestions instead.
  skipSuggestions?: boolean;
}

export interface BankDetail {
  bankAcct: string;
  name?: string;
  myBooksBalance: number;
  bankBalance: number;
  bankType: BankType
  bankAcctNo?: string;
  // Whether this account already has recorded bank transactions — used to show
  // "View" instead of "Add entry" for accounts not linked to Plaid.
  hasActivity?: boolean;
}

/** AI Suggest runs used this month against the edition's cap (limit -1 = unlimited). */
export interface AiUsage {
  used: number;
  limit: number;
  remaining: number | null;
  resetsAt: string;
}

/** Suggestions for one pending bank line, from GET /banking/suggestions. */
export interface BankLineSuggestions {
  ruleSuggestion?: RuleSuggestion;
  autoMatchSuggestions?: AutoMatchSuggestion[];
}

export interface AiBankSuggestion {
  accountId: string;
  accountName: string;
  contactId?: string;
  contactName?: string;
  confidence: 'high' | 'medium';
  reason: string;
  dismissed?: boolean;
}

// MBAI-528: Automatch Rules — mirrors mybooks-backend/src/banking/bank-rule.schema.ts.
// 'accountId'/'contactId' are listed for forward-compat but rejected server-side today —
// a bank line has neither field until it's categorized (see bank-rule.service.ts).
export type RuleConditionField = 'description' | 'amount' | 'direction' | 'reference' | 'dayOfMonth' | 'accountId' | 'contactId';
export type RuleConditionOperator = 'contains' | 'equals' | 'between' | 'gt' | 'lt';

export interface RuleCondition {
  field: RuleConditionField;
  operator: RuleConditionOperator;
  value?: string | number;
  valueMin?: number;
  valueMax?: number;
}

export interface RuleAction {
  objectType: 'Expense' | 'Income' | 'Transfer';
  // Kept for forward-compat with the design mocks, but not yet applied on Confirm —
  // the Expense write path has no contact/tax plumbing today. Category-only for v1.
  categoryId?: string;
  contactId?: string;
  taxId?: string;
  transferToAccountId?: string;
}

export interface BankRule {
  ruleId: string;
  bankAcct?: string;
  name: string;
  conditions: RuleCondition[];
  action: RuleAction;
  enabled: boolean;
  priority: number;
  hitCount: number;
  lastAppliedAt?: Date;
  effectiveFrom?: Date;
  source: 'quick' | 'manual';
}

/** Computed live server-side (never persisted) — see BankRuleService.evaluate(). */
export interface RuleSuggestion {
  ruleId?: string;
  ruleName?: string;
  objectType?: string;
  categoryId?: string;
  contactId?: string;
  taxId?: string;
  hitCount?: number;
}

export interface CreateBankRuleDto {
  bankAcct?: string;
  name?: string;
  conditions: RuleCondition[];
  action: RuleAction;
  enabled?: boolean;
  priority?: number;
  source?: 'quick' | 'manual';
  // true = "apply to those N now"; false/omitted = "only future imports" (the editor's default).
  applyNow?: boolean;
}

export interface UpdateBankRuleDto {
  name?: string;
  bankAcct?: string;
  conditions?: RuleCondition[];
  action?: RuleAction;
  enabled?: boolean;
  priority?: number;
}

export interface RulePreviewResult {
  count: number;
  total: number;
}

// The "In myBooksAi" column of the reconciliation board — ledger-side items not yet
// linked to a bank line. See BankingService.getUnmatchedLedgerItems.
export interface UnmatchedLedgerItem {
  objectId: string;
  objectType: string;
  objectNo?: string;
  contactName?: string;
  amount: number;
  date: Date;
  dueDate?: Date;
  status?: string;
}

export interface BankTransactions {
  bankTxnId: string;
  bankAcct: string;
  txnDate: Date;
  detail: string;
  reference: string;
  isCategorised: boolean;
  objectId: string;//TxnId or PaymentId
  objectType: string;
  isMatched: boolean;
  deposit: number;
  withdrawal: number;
  autoMatchSuggestions?: AutoMatchSuggestion[]
  balance?: number;
  balanceMatch?: boolean;
  balanceDiff?: number;
  aiSuggestion?: AiBankSuggestion;
  ruleSuggestion?: RuleSuggestion;
  // Input-only — set right before upsertBankTransaction when confirming a Rule
  // suggestion, so the backend can bump that rule's hitCount. Never read back.
  appliedRuleId?: string;
  // 'plaid' rows carry Plaid's transaction_id in `reference` (an opaque dedup key, not
  // user-meaningful); 'import' rows carry the CSV/OFX memo there instead.
  source?: 'import' | 'plaid';
}

export interface LoginInfo {
  ipAddress?: string;
  deviceType?: string;  // "mobile" | "tablet" | "desktop"
  deviceName?: string;  // "iPhone 15"
  osName?: string;      // "iOS 17"
  browser?: string;     // "Chrome 120"
  location?: string;    // IANA timezone or city/country
}

export interface LoginDto {
  email: string;
  password: string;
  bizId?: string;
  loginInfo?: LoginInfo;
}

export interface BulkCategoriseParams {
  transactionType?: string;
  targetAcct?: string;
  splitTransactions?: boolean;
  reference?: string;
  txnDate?: Date;
  // MBAI-528: set when confirming a Rule-sourced suggestion so the backend can bump
  // that rule's hitCount ("Applied to N lines"). Omitted for every non-rule categorization.
  appliedRuleId?: string;
}

export interface OTPInfo {
  email: string;
  otp_num: number;
}

export class SignupDTO {
  email: string = '';
  password: string = '';
  otp_num: number = 0;
  bizName: string = '';
  bizType: string = ''
  country: string = '';
  currency: string = '';
  timezone?: string;
  brand?: string;
  language?: string;
  constructor(data: Partial<SignupDTO> = {}) {
    Object.assign(this, data);
  }
}


export enum DateFormats {
  /** MDY (Month, Day, Year) - e.g., "August 21, 2024" */
  "MMMM d, yyyy" = "MMMM d, yyyy",

  /** DMY (Day, Month, Year) - e.g., "21 August, 2024" */
  "d MMMM, yyyy" = "d MMMM, yyyy",

  /** ISO (ISO 8601) - e.g., "2024-08-21" */
  "yyyy-MM-dd" = "yyyy-MM-dd",

  /** USA (MM/dd/yyyy) - e.g., "08/21/2024" */
  "MM/dd/yyyy" = "MM/dd/yyyy",

  /** EUR (dd. MM. yyyy) - e.g., "21. 08. 2024" */
  "dd. MM. yyyy" = "dd. MM. yyyy",

  /** IND (dd-MM-yyyy) - e.g., "21-08-2024" */
  "dd-MM-yyyy" = "dd-MM-yyyy",

}


export enum OwnershipType {
  SoleProprietorship = "Sole Proprietorship",
  Partnership = "Partnership",
  Corporation = "Corporation",
}



export type BizDetails = {
  bizName?: string;
  email?: string;
  phone?: string;
  address?: string;
  bankInfo?: string;
  country?: string;
  upiHandle?: string;
  currency?: string;
  website?: string;
  taxId?: string;
  customFields?: CustomField[];
  legalName?: string;
  salesTaxId?: string;
  accountingType?: AccountingType;
  bizType?: string;
  dateFormat?: DateFormats;
  ownershipType?: OwnershipType;
  fiscalYear?: string;
  timeZone?: string;
  logo?: string;
  seal?: string;
  sign?: string;
};

export type BizMaster = {
  bizId: string;
  branchId: string;
  bizDetails?: BizDetails;
  onboardingProgress?: OnboardingProgress;
};

export interface KVPairs {
  key: string;
  object?: string;
  value?: string;
  arrayValue?: string[];
}

export interface BulkDownloadResponse {
  successful: number;
  failed: number;
  downloadUrl?: string; // Single URL instead of array
}






export class ReportFilter {
  dateFilter: DateFilter = new DateFilter();
  selectedAccount?: Account;
  accountFilter?: string[];
  contactFilter?: string[];
  itemFilter?: string[];
  onlyCashEntries?: boolean;
  txnType?: TxnType;
  ledgerType?: LedgerType;
  accountingType?: AccountingType = AccountingType.Accrual;
  reportType?: ReportQueryType;
  includeBalance?: boolean;
  branchId?: string;
  tagsFilter?: string[];
  projectFilter?: string;
  contactCategoryFilter?: string[];
  contactGroupFilter?: string[];
  itemCategoryFilter?: string[];
  itemGroupFilter?: string[]; // MBAI-451
  includeRetainedEarnings?: boolean;
  comparePreviousPeriod?: boolean;
  agingBucketSize?: number; // Days per aging bucket (e.g. 7/15/30) — used by Aging Summary/Details
  constructor(data: Partial<ReportFilter> = {}) {
    Object.assign(this, data);
  }
};


export interface ProfitnLossDTO {
  income: number;
  expense: number;
  netPL: number;
  period: string;
}

export interface BizList {
  bizId: string;
  bizName: string;
  branchId?: string;
  hasBranch?: boolean;
}

export interface PendingInvite {
  bizId: string;
  bizName: string;
  role: string;
  invitedAt?: Date;
}

export interface CreateBizDTO {
  bizName?: string;
  country?: string;
  currency?: string;
  bizType?: string;
  timeZone?: string;
  brand?: string;
}





export interface cashFlowDTO {
  balance: number;
  period: string;
}

export interface ExpenseCategoryDTO {
  expenseCategory: string;
  amount: number;
}

export interface KPIDTO {
  operatingPM: number; // Operating Profit Margin
  sales: number;
  expense: number;
  overdue: number; // Static value
  bankBalance: number; // Static value
  myBooksBalance: number; // Static value
  cashBalance: number; // Static value
}

export interface DashboardResponse {
  profitnLossData: ProfitnLossDTO[];
  cashFlowData: cashFlowDTO[];
  expenseCategories: ExpenseCategoryDTO[];
  kpis: KPIDTO;
}

// ── Dashboard API v2 types ────────────────────────────────────────────────────

export interface PeriodKPIs {
  sales: number;
  expense: number;
  operatingPM: number;
  netProfit: number;
}

export interface PeriodData {
  fromDate: string;
  toDate: string;
  profitnLossData: ProfitnLossDTO[];
  cashFlowData: cashFlowDTO[];
  expenseCategories: ExpenseCategoryDTO[];
  kpis: PeriodKPIs;
}

export interface BalancesDTO {
  bankBalance: number;
  myBooksBalance: number;
  cashBalance: number;
  overdue: number;
}

export interface DashboardResponseV2 {
  current: PeriodData;
  prior: PeriodData;
  balances: BalancesDTO;
}

export interface DashboardNeedsAttentionDTO {
  overdueInvoiceCount: number;
  overdueInvoiceTotal: number;
  dueSoonInvoiceCount: number;
  dueSoonInvoiceTotal: number;
  dueSoonBillCount: number;
  dueSoonBillTotal: number;
  uncategorizedCount: number;
  uncategorizedTotal: number;
  dueSoonDays: number;
}

export enum SocialLogins {
  Apple = 'apple',
  Google = 'google',
}

export interface SocialSignInDto {
  sToken: string;
  provider: SocialLogins;
  onlyLogin: boolean;
  bizId?: string;
  loginInfo?: LoginInfo;
}

export type SocialSignUpDto = {
  sToken?: string;
  provider?: SocialLogins;
  onlyLogin?: boolean;
  bizName?: string;
  country?: string;
  currency?: string;
  bizType?: string;
  brand?: string;
  language?: string;
};

export type ScreenAccess = {
  screen: string;
  isAuthorized: boolean;
}

export type FunctionAccess = {
  function: string;
  isAuthorized: boolean;
}


export type ApiAccess = {
  apiPath: string;
  isAuthorized: boolean;
}

export type AccessLevel = 'none' | 'read' | 'write' | 'full';

export interface ObjectPermission {
  objectType: string;
  accessLevel: AccessLevel;
  // MBAI-525: field-level visibility flags layered on top of accessLevel above.
  // Only meaningful for objectType 'Item' (hidePurchaseRate) / 'Contact' (hideBalance).
  hidePurchaseRate?: boolean;
  hideBalance?: boolean;
}

export interface ObjectDefinition {
  objectType: string;
  label: string;
  category: string;
  description?: string;
}

export type AvailablePermissions = {
  objectCatalogue: ObjectDefinition[];
};

export type RoleAccess = {
  role: string;
  permissions: ObjectPermission[];
  allDataAccess: boolean;
  isAdmin: boolean;
  // legacy fields kept for backward compatibility
  screenAccess?: ScreenAccess[];
  functionAccess?: FunctionAccess[];
  apiAccess?: ApiAccess[];
}

export type CustomRole = {
  roleId?: string;
  roleName: string;
  allDataAccess: boolean;
  permissions: ObjectPermission[];
  createdBy?: string;
  modifiedBy?: string;
}

export class User {
  userId?: string;
  email?: string;
  phone?: string;
  password?: string;
  userName?: string;
  role?: string;
  forgotPasswordCode?: string;
  socialSign?: SocialLogins[];

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }
}

export class ActivateUserDto {
  activationCode?: string;
  password?: string;
  socialSignIn?: SocialLogins;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }
}

export class ComboItem {
  itemId?: string;
  qty?: number;

  constructor(init?: Partial<ComboItem>) {
    Object.assign(this, init);
  }
}

export class ItemPrice {
  itemId?: string;
  rateType?: string;
  itemRate?: number;
  discountPct?: number;
  chgPct?: number;
  chgType?: string;
  chgFrom?: string;

  constructor(init?: Partial<ItemPrice>) {
    Object.assign(this, init);
  }
}

export enum PriceListType {
  MarkUpDown = 'Mark up/Down',
  WholeAmount = 'Whole Amount'
}

export class PriceList {
  pricingId: string = generateShortUUID();;
  pricingName: string = '';
  pricingTxt?: string;
  itemsFilter?: string[];
  itemCategoryFilter?: string[];
  itemGroupFilter?: string[];
  contactsFilter?: string[];
  contactsCategory?: string[];
  contactsGroup?: string[];
  qtyOperator?: string;
  qtyLowerLimit?: number;
  qtyUpperLimit?: number;
  markupPct?: number;
  markupType?: string = 'MarkDown';
  discountPct?: number;
  isDiscountPct?: boolean;
  isTaxInclusive?: boolean;
  dateFrom?: Date;
  dateTo?: Date;
  comboItems?: ComboItem[];
  comboFlag?: boolean;
  itemPrices?: ItemPrice[];
  isActive?: boolean;
  priceFrom?: string;
  priceType?: PriceListType = PriceListType.MarkUpDown;
  isDeleted?: boolean;
  bizId?: string;

  constructor(init?: Partial<PriceList>) {
    Object.assign(this, init);
  }
}

export class PricingService {
  static getPrice(
    priceLists: PriceList[],
    item: Item,
    qty: number,
    contact?: Contact,
    taxPct?: number
  ): { finalPrice: number; markupPct?: number; discountPct?: number, priceListName: string, isDiscountPct?: boolean } | null {

    // Step 1: Filter valid price lists
    if (!priceLists) return null
    const validPriceLists = priceLists?.filter((priceList) => {
      const now = new Date();
      const isActive = priceList.isActive !== false && !priceList.isDeleted;
      const dateFrom = priceList.dateFrom ? new Date(priceList.dateFrom) : null;
      const dateTo = priceList.dateTo ? new Date(priceList.dateTo) : null;
      const inDateRange =
        (!dateFrom || now >= dateFrom) &&
        (!dateTo || now <= dateTo);

      const isFilterValid = (
        filter: string | any[] | undefined,
        value?: string,
        propertyToMatch?: string
      ) => {
        return (
          !filter ||
          filter.length === 0 ||
          (Array.isArray(filter) &&
            (propertyToMatch
              ? filter.some((item) => item[propertyToMatch] === value) // Match specific property
              : filter.includes(value)) // Assume it's an array of strings
          )
        );
      };


      const itemFilter =
        isFilterValid(priceList.itemsFilter, item.itemId) &&
        isFilterValid(priceList.itemCategoryFilter, item?.itemCategory) &&
        isFilterValid(priceList.itemGroupFilter, item.itemGroup);


      const qtyFilter =
        (!priceList.qtyLowerLimit || qty >= priceList.qtyLowerLimit) &&
        (!priceList.qtyUpperLimit || qty <= priceList.qtyUpperLimit);

      const contactFilter =
        isFilterValid(priceList.contactsFilter, contact?.contactId) &&
        isFilterValid(priceList.contactsCategory, contact?.contactCategory) &&
        isFilterValid(priceList.contactsGroup, contact?.contactGroup);

      const itemWholeAmount =
        isFilterValid(priceList.priceType, PriceListType.MarkUpDown) ||
        isFilterValid(priceList.itemPrices, item.itemId, 'itemId')

      return isActive && itemFilter && inDateRange && qtyFilter && contactFilter && itemWholeAmount // && itemFilter && qtyFilter && contactFilter;
    });
    // Step 2: Sort by restrictiveness
    const sortedPriceLists = validPriceLists.sort((a, b) => {
      const aFilters = [
        a.itemsFilter?.length || 0,
        a.itemCategoryFilter?.length || 0,
        a.itemGroupFilter?.length || 0,
        a.contactsFilter?.length || 0,
        a.contactsCategory?.length || 0,
        a.contactsGroup?.length || 0,
        a.qtyLowerLimit ? 1 : 0,
        a.qtyUpperLimit ? 1 : 0,
        a.dateFrom ? 1 : 0,
        a.dateTo ? 1 : 0,
      ].reduce((sum, val) => sum + val, 0);

      const bFilters = [
        b.itemsFilter?.length || 0,
        b.itemCategoryFilter?.length || 0,
        b.itemGroupFilter?.length || 0,
        b.contactsFilter?.length || 0,
        b.contactsCategory?.length || 0,
        b.contactsGroup?.length || 0,
        b.qtyLowerLimit ? 1 : 0,
        b.qtyUpperLimit ? 1 : 0,
        b.dateFrom ? 1 : 0,
        b.dateTo ? 1 : 0,
      ].reduce((sum, val) => sum + val, 0);

      return bFilters - aFilters; // More restrictive filters first
    });

    // Step 3: If no valid price list is found, return null
    if (!sortedPriceLists.length) {
      return null;
    }

    // Step 4: Apply the most restrictive price list
    const priceList = sortedPriceLists[0];
    const itemPriceEntry = priceList.itemPrices?.find((ip) => ip.itemId === item.itemId);
    const basePrice = (priceList.priceFrom === 'MRP') ? (item?.mrp || item.itemRate || 0) : itemPriceEntry?.itemRate || item.itemRate || 0;
    const priceListName = priceList.pricingName
    let finalPrice = basePrice;
    let markupPct = 0;
    let discountPct = 0;

    // Apply markup/markdown
    if (priceList.priceType === PriceListType.MarkUpDown) {
      if (priceList.markupType === 'MarkUp') {
        finalPrice = basePrice + (basePrice * (priceList.markupPct || 0)) / 100;
        markupPct = priceList.markupPct || 0;
      } else {
        finalPrice = basePrice - (basePrice * (priceList.markupPct || 0)) / 100;
        markupPct = -(priceList.markupPct || 0);
      }
    } else {
      finalPrice = basePrice;
    }

    // Apply discount
    if (priceList.discountPct) {
      discountPct = priceList.discountPct;
      // finalPrice -= (finalPrice * discountPct) / 100;
    }

    const isDiscountPct = priceList.isDiscountPct ?? !!(priceList.discountPct)

    // MBAI-XXX: priceList.isTaxInclusive means basePrice (and, for a flat discount,
    // discountPct-as-amount) are entered tax-inclusive (e.g. MRP). The rest of the
    // pipeline (calculateItemRate/recalculateAmounts) treats itemRate as tax-exclusive
    // and adds tax back on top, so convert both here before returning. A percentage
    // discount needs no conversion — it scales itemRate*qty either way.
    if (priceList.isTaxInclusive && taxPct) {
      const taxFactor = 1 + taxPct / 100;
      finalPrice = finalPrice / taxFactor;
      if (!isDiscountPct && discountPct) {
        discountPct = discountPct / taxFactor;
      }
    }

    return { finalPrice, markupPct, discountPct, priceListName, isDiscountPct  };
  }
}

export class SendTxnWPDto {
  phoneNumber?: string[];
  txnId?: string;
  txnType?: string;
  txnNo?: string;
  htmlContent?: string;
  customerName?: string;
  amount?: number;
  businessName?: string;
  currencyId?: string;
  country?: string;
  pdfUrl?: string;
  pdfFilename?: string;

  constructor(data: Partial<SendTxnWPDto>) {
    Object.assign(this, data);
  }
}

export interface ApiKey {
  // Stable identifier used for update/delete. The secret itself is never returned after creation.
  keyId: string;
  // First 8 characters of the key, so users can tell keys apart.
  keyPrefix?: string;
  name: string;
  // Any built-in role name (Admin/Staff/Accountant) or the business's own custom role name —
  // see AuthService.getEffectiveRoleAccess() on the backend, which resolves both.
  role: string;
  enabled: boolean;
  createdAt: string;
  lastUsed?: string;
}

export interface CreateApiKeyRequest {
  name: string;
  role?: string;
}

export interface UpdateApiKeyRequest {
  keyId: string;
  name?: string;
  role?: string;
  enabled?: boolean;
}

// Define possible response structures
export interface ApiKeyListResponse {
  apiKeys: ApiKey[];
  success?: boolean;
}

// Returned by createApiKey only. `apiKey` is the full secret, shown once and never stored in plaintext.
export interface ApiKeyResponse {
  keyId: string;
  keyPrefix?: string;
  apiKey: string;
  name: string;
  role: string;
  enabled: boolean;
  createdAt: string;
  lastUsed?: string;
}

export interface DeleteConfirmationResponse {
  message: string;
  expiryTime: string;
}

export interface BulkDeleteTxnDto {
  txnIds: string[];
}

export interface BulkDeleteResponse {
  totalRequested: number;
  successful: number;
  failed: number;
  results: Array<{
    txnId: string;
    success: boolean;
    error?: string;
  }>;
}

export interface BulkOperationItem {
  id: string;
  displayName: string; // txnNo, contactName, etc.
  status: 'pending' | 'processing' | 'success' | 'failed';
  error?: string;
}

export interface BulkOperationProgress {
  total: number;
  completed: number;
  successful: number;
  failed: number;
  items: BulkOperationItem[];
}

export interface BulkDeleteResponse {
  totalRequested: number;
  successful: number;
  failed: number;
  results: Array<{
    txnId: string;
    success: boolean;
    error?: string;
  }>;
}

export interface OnboardingProgress {
  userId: string;
  bizId: string;
  isEnabled: boolean; // Whether to display onboarding or not
  isDismissed: boolean;
  steps: Record<string, boolean>;
  lastUpdated: Date;
  completedAt?: Date;
}

export interface ItemAnalytics {
  itemId: string;

  // Profit Metrics
  profitMargin: number;
  profitPerUnit: number;

  // Sales Metrics
  salesLastMonth: {
    quantity: number;
    revenue: number;
    revenueWithTax: number;
    transactionCount: number;
  };

  // Inventory Metrics
  currentStock: number;
  stockValue: number;
  averageCostPrice: number;

  // Optional Metrics
  reorderLevel?: number;
  stockStatus?: 'InStock' | 'LowStock' | 'OutOfStock' | 'Critical';
}

export interface SalesMetrics {
  quantity: number;
  revenue: number;
  revenueWithTax: number;
  transactionCount: number;
}

// ============================================
// Subscription Types - Add these to your types.ts file
// ============================================

export interface ValidatedPricing {
  item: string;
  edition: 'Free' | 'Standard' | 'Premium' | 'Enterprise';
  country_code: string;
  frequency: 'Monthly' | 'Quarterly' | 'HalfYearly' | 'Yearly';
  currency: string;
  base_price: number | null;
  tax_rate: number;
  tax_value: number | null;
  total_before_offer: number | null;
  final_amount: number | null;
  offer_applied: string | null;
}

export interface CheckoutResponse {
  sessionId: string;
  provider: 'Razorpay' | 'Stripe';
  orderId?: string;
  keyId?: string;
  amount: number | null;
  currency: string;
  checkoutUrl?: string;
  validatedPricing: ValidatedPricing;
}

export interface CheckoutRequest {
  item: string;
  edition: 'Free' | 'Standard' | 'Premium' | 'Enterprise';
  country_code: string;
  frequency: 'Monthly' | 'Quarterly' | 'HalfYearly' | 'Yearly';
  users: number;
}

export interface ConfirmPaymentRequest {
  sessionId: string;
  provider: 'Razorpay' | 'Stripe';
  razorpayPaymentId?: string;
  razorpayOrderId?: string;
  razorpaySignature?: string;
  paymentIntentId?: string;
  stripeSessionId: string;
}

export interface UsageLimits {
  maxUsers: number;
  maxTransactions: number;
  maxBankFeeds: number;
  maxBranches: number;
}

export interface TransactionInfo {
  transactionId: string;
  amount: number | null;
  currency: string;
  provider: string;
  paymentDate: string;
  status: string;
}

export interface CurrentPlan {
  edition: 'Free' | 'Standard' | 'Premium' | 'Enterprise';
  provider: string;
  status: 'active' | 'inactive' | 'cancelled' | 'trial' | 'expired' | 'trialing';
  startDate: string;
  endDate: string;
  trialEndsAt: string | null;
  autoRenew: boolean;
  isTrial: boolean;
  recurrence: string;
  usageLimits: UsageLimits;
  txnInfo?: TransactionInfo;
}

export interface SubscriptionData {
  bizId: string;
  currentPlan: CurrentPlan;
}

export interface ConfirmPaymentResponse {
  success: boolean;
  subscription: SubscriptionData;
}

// ============================================
// Subscription Types - Additional interfaces needed
// ============================================

export interface PricingRequest {
  item: string;
  edition: string;
  country_code: string;
  frequency: string;
}

//checking
export interface PricingResponse {
  item: string;
  edition: string;
  country_code: string;
  frequency: string;
  currency: string;
  base_price: number;
  tax_rate: number;
  tax_value: number;
  total_before_offer: number;
  final_amount: number;
  offer_applied: string | null;
}

export interface SubscriptionHistoryEntry {
  edition: string;
  provider: string;
  startDate: string;
  endDate: string;
  cancelledAt?: string;
  cancellationReason?: string;
  status: string;
}

export interface SubscriptionHistory {
  history: SubscriptionHistoryEntry[];
}

export type SearchObjectType =
  | 'contact' | 'item' | 'transaction' | 'payment' | 'ledger' | 'bankTransaction';

export interface SearchResultItem<M = Record<string, unknown>> {
  objectType: SearchObjectType;
  id: string;
  displayText: string;
  subText: string;
  navigateTo: string;
  score: number;
  meta: M;
}
export interface ContactMeta { contactType: string[] }
export interface ItemMeta { itemCategory: string | null }
export interface TransactionMeta { txnType: string | null; txnStatus: string | null; totalAmt: number | null }
export interface PaymentMeta { paymentType: string | null; paymentStatus: string | null; totalAmt: number | null }
export interface LedgerMeta { ledgerType: string | null }
export interface BankTransactionMeta { isCategorised: boolean | null; deposit: number | null; withdrawal: number | null; bankAcct: string | null }
export interface SearchResults {
  contacts?: SearchResultItem<ContactMeta>[];
  items?: SearchResultItem<ItemMeta>[];
  transactions?: SearchResultItem<TransactionMeta>[];
  payments?: SearchResultItem<PaymentMeta>[];
  ledger?: SearchResultItem<LedgerMeta>[];
  bankTransactions?: SearchResultItem<BankTransactionMeta>[];
}
export interface SearchResponse { q: string; results: SearchResults; totalCount: number }

// ── Documents ─────────────────────────────────────────────────────────────────
export type DocumentSourceType = 'document' | 'transaction' | 'payment';

export interface DocumentListItem {
  sourceType: DocumentSourceType;
  documentId: string | null;
  documentName: string | null;
  notes: string | null;
  group: string | null;
  contentType: string | null;
  fileSize: number | null;
  createdBy: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  fileKey: string;
  txnId: string | null;
  txnNo: string | null;
  txnType: string | null;
  txnDate: string | null;
  contactId: string | null;
  contactName: string | null;
  totalAmt: number | null;
}

export interface StorageInfo {
  edition: string;
  limitMB: number;
  usedMB: number;
  usedBytes: number;
  limitBytes: number;
  availableBytes: number;
}

export interface UploadDocumentMetadata {
  documentName: string;
  notes?: string;
  group?: string;
}

export interface DeleteDocumentResponse {
  deletedCount: number;
}

export interface UserProfile {
  userId: string;
  userName?: string;
  email: string;
  phone?: string;
  app?: string;
  isActivated?: boolean;
  socialSign?: SocialLogins[];
  lastLogin?: { loginAt: string; [key: string]: any };
  bizId?: string;
  branchId?: string;
  role?: string;
  language?: string;
}

// ─── Projects ────────────────────────────────────────────────────────────────

export interface ProjectSettings {
  enabled?: boolean;
}

export type ProjectStatus = 'Active' | 'OnHold' | 'Completed' | 'Cancelled';
export type MilestoneStatus = 'Pending' | 'Invoiced' | 'Paid';

export interface ProjectMilestone {
  milestoneId?: string;
  name: string;
  dueDate?: Date;
  billingAmount?: number;
  status?: MilestoneStatus;
  linkedInvoiceIds?: string[];
}

export interface Project {
  projectId?: string;
  projectNo?: string;
  name: string;
  status?: ProjectStatus;
  clientId?: string;
  contractValue?: number;
  budgetedIncome?: number;
  budgetedExpense?: number;
  startDate?: Date;
  expectedEndDate?: Date;
  actualEndDate?: Date;
  description?: string;
  milestones?: ProjectMilestone[];
  attachmentIds?: string[];
  bizId?: string;
  branchId?: string;
  isDeleted?: boolean;
}

export interface ProjectAttachment {
  documentId: string;
  documentName: string;
  fileKey: string;
  contentType?: string;
  fileSize?: number;
  createdAt?: Date;
}

export interface ProjectSummary {
  contractValue: number;
  budgetedIncome: number;
  budgetedExpense: number;
  invoiced: number;
  received: number;
  costs: number;
  grossProfit: number;
  budgetIncomeVariance: number;
  budgetExpenseVariance: number;
}

// ─── Budgets ──────────────────────────────────────────────────────────────────

export interface BudgetSettings {
  enabled?: boolean;
  defaultBudgetId?: string;
}

export type BudgetBasis = 'Monthly' | 'Annual';
export type BudgetStatus = 'Draft' | 'Active' | 'Archived';

export interface BudgetLine {
  lineId?: string;
  accountId: string;
  accountName: string;
  accountGroup?: string;
  accountType?: string;
  accountCategory?: string;
  // Monthly: 12 entries (index 0 = FY start month). Annual: 1 entry.
  periodAmounts: number[];
  notes?: string;
}

export interface Budget {
  budgetId?: string;
  budgetNo?: string;
  name: string;
  financialYear: string;
  fyFromDate?: Date;
  fyToDate?: Date;
  fiscalMonthStart?: number;
  basis: BudgetBasis;
  status?: BudgetStatus;
  notes?: string;
  lines?: BudgetLine[];
}

export interface BudgetVsActualRow {
  accountId: string;
  accountName: string;
  accountType?: string;
  accountCategory?: string;
  isSection?: boolean;
  isTotal?: boolean;
  budgetMonths: number[];
  actualMonths: number[];
  budgetTotal: number;
  actualTotal: number;
  variance: number;
  variancePct: number;
}

export interface BudgetVsActualResponse {
  budget: Partial<Budget>;
  rows: BudgetVsActualRow[];
  months: string[];
}

export interface UpdateRecurrenceSettings {
  recurrenceName?: string;
  recurrenceInterval?: string;
  recurrenceStartDate?: string;
  recurrenceEndDate?: string;
  recurrenceDisabled?: boolean;
  recurrenceSend?: boolean;
}

export type RecurrencePlanStatus = 'Active' | 'Paused' | 'Ended';

// MBAI-150: a RecurringTemplate is its own entity, never itself a live/sent Txn -- every
// occurrence (including the first) is generated from it as a distinct Txn carrying
// generatedFromTemplateId. Kept alongside (not replacing) the legacy recurrence* fields on
// TxnHeader above, which keep serving pre-existing production recurring series unmodified.
export class RecurringTemplate {
  templateId: string;
  bizId?: string;
  branchId?: string;
  templateName?: string;
  txnType: TxnType;
  recurrenceInterval: string;
  recurrenceStartDate?: Date;
  recurrenceEndDate?: Date;
  recurrenceDisabled?: boolean;
  recurrenceSend?: boolean;
  recurrenceLastRun?: Date;
  txnHeader: TxnHeader;
  lineItems?: LineItem[];
  createdBy?: string;
  modifiedBy?: string;
  // Computed at read-time by the backend -- never sent on upsert.
  nextRecurrenceDate?: Date;
  contactInfo?: Contact;

  constructor(data: Partial<RecurringTemplate> = {}) {
    this.templateId = data.templateId || '';
    this.bizId = data.bizId;
    this.branchId = data.branchId;
    this.templateName = data.templateName;
    this.txnType = data.txnType as TxnType;
    this.recurrenceInterval = data.recurrenceInterval || '';
    this.recurrenceStartDate = data.recurrenceStartDate ? new Date(data.recurrenceStartDate) : undefined;
    this.recurrenceEndDate = data.recurrenceEndDate ? new Date(data.recurrenceEndDate) : undefined;
    this.recurrenceDisabled = data.recurrenceDisabled ?? false;
    this.recurrenceSend = data.recurrenceSend ?? true;
    this.recurrenceLastRun = data.recurrenceLastRun ? new Date(data.recurrenceLastRun) : undefined;
    this.txnHeader = new TxnHeader(data.txnHeader || {}, data.txnType);
    this.lineItems = (data.lineItems || []).map(item => new LineItem(item));
    this.createdBy = data.createdBy;
    this.modifiedBy = data.modifiedBy;
    this.nextRecurrenceDate = data.nextRecurrenceDate ? new Date(data.nextRecurrenceDate) : undefined;
    this.contactInfo = data.contactInfo;
  }
}

export interface UpsertRecurringTemplateDto {
  templateName?: string;
  txnType?: TxnType;
  recurrenceInterval?: string;
  recurrenceStartDate?: string;
  recurrenceEndDate?: string;
  recurrenceDisabled?: boolean;
  recurrenceSend?: boolean;
  txnHeader?: Partial<TxnHeader>;
  lineItems?: LineItem[];
}

export interface BudgetDashboardWidget {
  budgetId: string;
  budgetName: string;
  financialYear: string;
  totalBudgetIncome: number;
  ytdBudgetIncome: number;
  ytdActualIncome: number;
  totalBudgetExpense: number;
  ytdBudgetExpense: number;
  ytdActualExpense: number;
  netBudgetProfit: number;
  netActualProfit: number;
  topOverspentAccounts: {
    accountId: string;
    accountName: string;
    budgetAmount: number;
    actualAmount: number;
    overspend: number;
    overspendPct: number;
  }[];
}



// Opening-balance sync (mirrors the backend's OpeningBalancePreview)
export type OpeningBalanceSource = 'plaid' | 'statement' | 'entered';

export interface OpeningBalanceProposal {
  source: OpeningBalanceSource;
  confidence: 'high' | 'medium' | 'low';
  openingBalanceAmt: number;
  openingBalanceDate: string;
  referenceBalance: number;
  referenceDate: string;
  importedNet: number;
  txnCount: number;
}

export interface OpeningBalancePreview {
  bankAcct: string;
  accountName: string;
  isCreditCard: boolean;
  current: { amount: number; date?: string };
  proposal: OpeningBalanceProposal | null;
  needsInput: boolean;
  changed: boolean;
  hasOtherLedgerActivity: boolean;
  txnCount: number;
  firstTxnDate?: string;
  lastTxnDate?: string;
  applied?: boolean;
}
